import { render } from "./Tool88Page_CaseBuddy.vue?vue&type=template&id=3037b57a&scoped=true"
import script from "./Tool88Page_CaseBuddy.vue?vue&type=script&lang=js"
export * from "./Tool88Page_CaseBuddy.vue?vue&type=script&lang=js"

import "./Tool88Page_CaseBuddy.vue?vue&type=style&index=0&id=3037b57a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3037b57a"]])

export default __exports__